export default __webpack_public_path__ + "static/scale_it-7efe4a06d7c5ae6ac7a3b7f8cc588c30.webp";